import React from 'react';
import { useSelector } from 'react-redux';
import { usePreloadSubscriptionStatuses } from 'cityads-v3/utils/useUtils'
import { RootState } from 'cityads-v3/types/reducer';

type SubscriptionStatusProps = {
  children(name: string): JSX.Element
  id: string | number
  manualFetch: boolean
}

export default function SubscriptionStatus({ id, children, manualFetch }: SubscriptionStatusProps) {
  const status = useSelector((state: RootState) => state.subscriptionStatuses.subscriptionStatusesById[id]);
  const user = useSelector((state: RootState) => state.auth.user);

  usePreloadSubscriptionStatuses(manualFetch);

  return (
    user ?
      children ?
        status?.status_name ? children(status.status_name) : null
        :
        <>{status?.status_name}</>
      : null
  )
}
